export default "__VITE_ASSET__ad61665d__"